var oostend = {  
  product_page: function(){ 

    $('body').on('click', '.show_popup', function(){ 
      $('[data-quotify]').trigger( "click" );  
    }); 

    setTimeout(function(){
       delivery();  
      $('.submit_form').addClass('active');
    }, 2900);

    
    function delivery(){
      
      var deliver_html = $('[data-start-delivery]').html();
      var split = $('[data-end-delivery]').html(); 

      console.log(split);
      if(typeof split !== 'undefined'){
        $('.levertijd').val(split); 
      }
      
      if(typeof deliver_html !== 'undefined'){
         $('.levertijd').val(deliver_html+ ' - '+ split); 
      }else if(typeof split !== 'undefined'){ 
        $('.levertijd').val(split); 
      }else{
       var preorder_html = $('[preorder_template]').text();
         console.log(preorder_html);
         if(typeof preorder_html !== 'undefined'){
            $('.levertijd').val(preorder_html);
         }
      }

      
    }
    
  
    
     $("body").on("input.wdht_style", function(){         
   		//oostend.wdht_style(); 
       oostend.find_dimensions();
    });
    
    $('.proFeaturedImage').on('click', function(e){
      if($(window).width() < 992){
        e.preventDefault();
      }
    });
    
   
    
    // varinat
    $('body').on('click','.select_option_custom .var_option', function(){
      var value=$(this).data('name');
      $('.selected_optin .select_value').html(value);
      $('select.single-option-selector').val(value).trigger('change');
      $('.select_option_custom .var_option').removeClass('active');
      $(this).addClass('active');      
    });
    
    
    // collection
    $('body').on('click', '.select_option_custom .var_option_box', function(){
        var value = $(this).data('value');
        $(this).closest('.select_option_custom').find('.var_option_box').removeClass('active');
        $(this).addClass('active');      
        $('.collection_variant').val(value);
    });
  
   
    
    $('body').on('click', '.mlop_btn[data-id="3"], .show_popup', function(){ 
     // $('[data-quotify]').trigger("click"); 
      $('quotify-button').trigger("click"); 
      console.log('aa');
    });
    
    $('.mlop_btn[data-id="1"]').on('click', function(){
       $('.calculation_section_outer').slideToggle();
    });
    
    $('.popup_close, .popup_outer').on('click', function(){
    	$('.popup_section').fadeOut();
    });
     
    
     $('body').on('click', '.thumbnails .thumbnail', function(){
      change_value($(this));
       
    });
    
    function change_value(that){
      var select_url = '';
      setTimeout(function(){
         var url = that.data('url');
        
         select_url = $('select[name="id"] option[data-img="'+url+'"]').html();     
        
         if(typeof select_url !=='undefined'){  
           
            if(select_url.indexOf('/')!= -1){
               var a= select_url.split("/");
               select_url = $.trim(a[0]);
             }
          
           var current_val = $('#SingleOptionSelector-0').val();  
          console.log(select_url);
          if(current_val !=select_url){
           // $('[data-option-index="0"] .cc-select__btn').attr('aria-expanded','true').trigger('click');
           //  $('[data-option-index="0"] .cc-select__listbox').removeAttr('hidden').attr('aria-hidden', 'false');
           // $('[data-option-index="0"] .cc-select').addClass('is-open');
           // $('.cc-select__option[data-value="'+select_url+'"]').attr('aria-selected','true').trigger('click').addClass('is-focused');

           /* let element = document.getElementById("button_template--14337535639632__main-6624688537680-colour-selector");
            let changeEvent = new Event('click');
              element.dispatchEvent(changeEvent);
              */
            
              //$('.js-option[value="'+select_url+'"]').prop("checked", true).trigger('change'); 
             //$('#SingleOptionSelector-0').val(select_url).trigger('change');
          }
           
         }
        
      },10);

     
    }
    
    
  },
  find_dimensions_reset: function(){
    $('input#width_input').val('');
    $('input#height_input').val(''); 

       var sample = $('[name="id"].t4s-product__select option:selected').text();
       if(sample.indexOf('Sample') == -1 && sample.indexOf('Muster') == -1){
         var min = parseInt($('.t4s-form__product').data('min'));
         
         if(!isNaN(min))
         $('.t4s-quantity-wrapper input[name="quantity"]').val(min);
       }else{
         $('.t4s-quantity-wrapper input[name="quantity"]').val(1);
       }
    
    oostend.find_dimensions();
   
     setTimeout(function() {
       oostend.find_dimensions();
        
     },300);

    /*
    if(typeof $('input#width_input').val() !== 'undefined'){
      var roll = $('.width_height').attr('data-rol');
      if(roll != 'true'){
         setTimeout(function() {
          $('[data-atc-form]').attr('disabled', 'disabled');
           
        }, 400);
      };
    }
    */
   
  },
  find_dimensions: function(){
       var width = parseInt($('input#width_input').val());
       var height = parseInt($('input#height_input').val());   
       var price =  parseInt($('.width_height').attr('data-price'));
       var size = parseInt($('.width_height').attr('data-size')); 

       var c= parseInt($('.width_height').attr('data-c')); 
       var d= parseInt($('.width_height').attr('data-d')); 
       var f= parseFloat($('.width_height').attr('data-f'));  
       var g= $('.width_height').attr('data-g'); 
       var r= $('.width_height').attr('data-g'); 
    
       var roll = $('.width_height').attr('data-rol');
       var Rtxt_1 = $('.width_height').attr('data-Rtxt1');
       var Rtxt_2 = $('.width_height').attr('data-Rtxt2');
       var alert_txt = $('.width_height').attr('data-alert');

      var max_size = $('.width_height').attr('data-maxcm');
      
       var txt = $('.pdmr_txt .pdmr_ms2').attr('data-val');
       var txt1 = $('.pdmr_txt .pdmr_ms2').attr('data-val1');
       var cm =  parseInt($('.width_height').attr('data-cm'));
       var rsmall =  $('.width_height').attr('data-small');
    
       var arr = null;   
         if(roll == 'true'){
           $('[data-atc-form]').removeAttr('disabled'); 
           setTimeout(function() { 
               // $('[data-atc-form]').removeAttr('disabled');  
           }, 100);
           
           $('.pdmr_error_msg').html('');
           if(height < 51 || width < 51){
              $('.pdmr_error_msg').html(rsmall);
              console.log(rsmall);
              return ;
           }
           
            if(height >=d && d != 100){
              $('.pdmr_txt .pdmr_ctxt').html('');
              $('.pdmr_txt .pdmr_ms2').html('');
              
              $('.pdmr_error_msg').html(alert_txt);
              $('.t4s-quantity-wrapper input[name="quantity"]').val(1);
              return ;
            }else if(g == 'true'){ 
               

               var r13= f/2;
               var r14 = Math.ceil((height+5)/r13);
              var r15 = r14*r13;
              var r17 = Math.ceil((width+5)/c);
              var R19 = 0;
              if (r14 % 2 === 0) {
                  R19 =parseInt(r17/2);
              } 
              var R20=(r15+r13);
              if(d==100){
                 arr = Math.ceil(((r17-R19)*r15)/d+(R19*R20)/d);
              }else{
                arr = Math.ceil(((r17-R19)*r15)/d)+Math.ceil((R19*R20)/d);
              }
 
              
            }else if(d== 100 && f > 0){  
              
                var r9 = Math.ceil((height+5)/f);
                var r10 = r9*f;
                var r11 = r10/d;
                var r12 = Math.ceil((width+5)/c);
                arr = Math.ceil(r11*r12);
                
              
            }else if(d == 100 && f == 0){
              
               var r7 = Math.ceil((width+5)/c);
               var r8 = (height+5)/d;
               arr = Math.ceil(r7*r8);
              
            }else if(f > 0){

              var r3 = Math.ceil((height+5)/f);
              var r4 = r3*f;
              var r5 = parseInt(d/r4);
              var r6 = Math.ceil((width+5)/c);
              arr = Math.ceil(r6/r5);  
              
            }else if(f == 0){

               var r1 = Math.ceil((width+5)/c);
               var r2 = parseInt(d/(height+5));
               arr = Math.ceil(r1/r2);
            }
            
           if(!isNaN(arr)){
             if(arr === Infinity){
                $('.pdmr_error_msg').html(alert_txt);
                $('.t4s-quantity-wrapper input[name="quantity"]').val(1);
               return;
             }
             
              $('.pdmr_txt .pdmr_ctxt').html(T4SThemeSP.Currency.formatMoney(arr*price));
              $('.t4s-quantity-wrapper input[name="quantity"]').val(arr);
              
              $('[data-atc-form]').removeAttr('disabled');  
              //$('.mnqt_show').show();

              
             if(Rtxt_1 != '' && typeof Rtxt_2 !== 'undefined'){
               var txt = Rtxt_1+' '+Rtxt_2+ ' | '+arr;
              $('.pdmr_txt .pdmr_ms2').html(txt);
             }
             
           }else{
             $('.pdmr_txt .pdmr_ctxt').html('');
             $('.pdmr_txt .pdmr_ms2').html(''); 
             $('.t4s-quantity-wrapper input[name="quantity"]').val(1);
           }
           
         }else{
           
         
          if(!isNaN(width)){
            width = width/size;
            width = Math.ceil(width);           
            width = width*size;
  
          } 
          arr = width*height/10000;  
         
        
       if(!isNaN(arr)){
         arr =  Math.ceil(arr);

         var txt =txt +' '+size+ txt1+' '+ arr;
         if(cm){
           txt1 = txt1.split('|');
           txt = txt1[1]+' '+ arr;

           if(height > 300 || width > 200){
             // alert(max_size);
              $('.sizecm').show();
             $('[data-atc-form]').attr('disabled', 'disabled');  
             return;
           }else{
             $('.sizecm').hide();
           }
         } 

         // set value
         var sample = $('[name="id"].t4s-product__select option:selected').text();
         if(sample.indexOf('Sample') == -1 && sample.indexOf('Muster') == -1){
            $('.pdmr_txt .pdmr_ctxt').html(T4SThemeSP.Currency.formatMoney(arr*price));
            $('.pdmr_txt .pdmr_ms2').html(txt);
            $('.t4s-quantity-wrapper input[name="quantity"]').val(arr);
         }else{
            $('.t4s-quantity-wrapper input[name="quantity"]').val(1);
         } 
        
         $('[data-atc-form]').removeAttr('disabled');  
         $('.mnqt_show').show();
       }else{
         $('.pdmr_txt .pdmr_ctxt').html('');
         $('.pdmr_txt .pdmr_ms2').html(''); 
         
        // $('[data-atc-form]').attr('disabled', 'disabled');  
         
       } 
          
      } 
        oostend.min_max_qty(); 
  },
  set_cookies: function(){
    $('.cookies_btn_style').on('click', function(){
      $('.cookies_banner').fadeOut();
      setCookie('cookies', 1);
    });
    
    if(getCookie('cookies') != 1){
      $('.cookies_banner').show();
       setCookie('cookies', 1); 
    }
    
      function setCookie(key, value) {
        var expiry = 1;
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
      }

      function getCookie(key) {
          var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
          return keyValue ? keyValue[2] : null;
      }
  }, 
  qty_change: function() {
    $('.t4s-pr__qty_cart input[name="quantity"]').on('change', function() { 
       //$('.mnqt_show').show();
       oostend.min_max_qty();

    });
  },
  min_max_qty: function(){
  
     var qty = parseInt($('.t4s-pr__qty_cart input[name="quantity"]').val());
     var min =$('.t4s-form__product').data('min'); 
    
    var sample = $('[name="id"].t4s-product__select option:selected').text();
  
      if(sample.indexOf('Sample') == -1 && sample.indexOf('Muster') == -1){  
          if(typeof min !== 'undefined' ){ 
             min = parseInt(min);
            if(qty >= min){
              $('[data-atc-form]').removeAttr('disabled'); 
              $('.mnqt_show').hide();
            }else{
              $('[data-atc-form]').attr('disabled', 'disabled');
             $('.mnqt_show').show();
               
            }
            $('.min_qty_value').html($('.min_qty_value').data('min'));
          }else{
             
            $('[data-atc-form]').removeAttr('disabled'); 
          }

        /*
         var roll = $('.width_height').attr('data-rol');
        if(roll !='true')
          if(typeof $('input#width_input').val() !== 'undefined' ){
             var width = parseInt($('input#width_input').val());
             var height = parseInt($('input#height_input').val()); 
            if(isNaN(width)  || isNaN(height)){
              $('[data-atc-form]').attr('disabled', 'disabled');
               
            } 
         }
        */
        
      }else{
        
         if(qty == 1){ 
            $('[data-atc-form]').removeAttr('disabled'); 
            $('.mnqt_show').hide();
           console.log(qty);
          }else{
            $('[data-atc-form]').attr('disabled', 'disabled');
             $('.mnqt_show').show(); 
          }
         $('.min_qty_value').html($('.min_qty_value').data('max'));

        // check add cart value 
        var current_id = $('[name="id"]').val();
        $.each(cart, function(index, item) {
             if(item.id == current_id){
                
               $('[data-atc-form]').attr('disabled', 'disabled');
               $('.mnqt_show').show(); 
             }
        });
        
      }
    
  },
  check_cart_value: function() {

    $('[data-atc-form]').on('click', function() { 
      setTimeout(function() {
         check_cart();
      }, 800);
     
    });

    function check_cart() {
      var current_id = $('[name="id"]').val();
       $.ajax({ 
          url: "/cart.js", 
         dataType: "json",
          success: function(result){  
            cart = result.items;
            
              $.each(result.items, function(index, item) {
                 if(item.id == current_id){
                 $('[data-atc-form]').attr('disabled', 'disabled');
                 $('.mnqt_show').show();
               }
              })
              
          }
      });
    }

    
  },
  colleciton_var: function() {

      $('.color_hover .t4s-pr-color__item').mouseover(function(){
         $('.t4s-pr-color__item').removeClass('is-swatch--selected');
        $(this).addClass('is-swatch--selected');
      });
  },
  price_update: function () {
      
     $('.t4s-product-price').each(function () {
        // Get the current text content and trim it
        let textValue = $(this).text().trim();
       // $(this).text(textValue.replace(/\.00$/, ""));
       
       /*
       textValue = textValue.replace('kr', '');
        textValue = textValue.replace(',', '');
        // Remove the dollar sign and parse the value as a float
        let numericValue = parseFloat(textValue.replace('$', ''));

        // Check if the value is valid
        if (!isNaN(numericValue)) {
            // Format the value: remove .00 if it's a whole number
            let formattedValue = Number.isInteger(numericValue) ? numericValue : numericValue.toFixed(2);
            // Update the text with the dollar sign
           $(this).text(`$${formattedValue}`);
        } else {
            // Replace invalid values with "Invalid"
           // $(this).text('Invalid');
        }
       */
    });

  },
  header_top_star: function() {

    top_star();

    setTimeout(function() {
       oostend.price_update();
     }, 900);
    setTimeout(function() {
       oostend.price_update();
     }, 1900);

    setTimeout(function() {
       oostend.price_update();
     }, 2900);
    setTimeout(function() {
       oostend.price_update();
     }, 3900);
    
    function top_star() {
          var html = $('#etrusted-trusted_stars_service').html();
          $('.top_star_box').html(html);
    }
         
    /*
      $.ajax({
        url: "/",
        success: function(resuelt){
          var html = $(resuelt).find('#etrusted-trusted_stars_service').html();
          $('.top_star_box').html(html);
        }
      });
      */
  }
} 
 
$(document).ready(function($) {
     oostend.product_page();
     oostend.qty_change();
     oostend.min_max_qty();

     oostend.colleciton_var();

     oostend.check_cart_value();
  
     oostend.header_top_star();
   
     setTimeout(function() {
       oostend.price_update();
     }, 50) 

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0); 
	   });

      
   

});




